const PRO_ITEMS_COLUMNS = [
  { id: "orderId", label: "ID", width: 150, fixed:'left' },
  { id: "productName", label: "PRODUCT NAME", width: 300,widget: "mediaText" },
  { id: "price", label: "PRICE", width: 150 ,widget: "number"},
  { id: "customer", label: "CUSTOMER", width: 200 },
  { id: "date", label: "DATE", width: 150 },
  { id: "status", label: "STATUS", width: 150, widget: "OrderStatus" }
];

// const COLUMNS_ATTACHMENTS = [
//   {
//     id: "name",
//     label: "Name",
//     width: 300,
//     widget: "file"
//   },{
//     id: "createrProfile",
//     label: "Owner",
//     widget: "staticmember",
//     width: 200
//   },  {
//     id: "lastModifiedDate",
//     label: "Created At",
//     widget: "date",
//     width: 200
//   }
// ];
  

const ROWS = [
  {
    orderId: "ORD-1001",
    productName: "Noise Cancelling Earbuds",
    price: 149.0,
    customer: "John Doe",
    date: "2025-09-01",
    status: "Placed"

  },
  {
    orderId: "ORD-1002",
    productName: "Smartwatch Series 7",
    price: 299.0,
    customer: "Alice Smith",
    date: "2025-09-02",
    status: "Processing"
   
  },
  {
    orderId: "ORD-1003",
    productName: "Bluetooth Speaker",
    price: 79.0,
    customer: "Michael Johnson",
    date: "2025-09-03",
    status: "Delivered"
  },
  {
    orderId: "ORD-1004",
    productName: "Gaming Mouse",
    price: 59.0,
    customer: "Sophia Lee",
    date: "2025-09-04",
    status: "Cancelled"
  },
  {
    orderId: "ORD-1005",
    productName: "Mechanical Keyboard",
    price: 129.0,
    customer: "David Brown",
    date: "2025-09-05",
    status: "Placed"
  },
  {
    orderId: "ORD-1006",
    productName: "4K Monitor",
    price: 399.0,
    customer: "Emma Wilson",
    date: "2025-09-06",
    status: "Processing"
  },
  {
    orderId: "ORD-1007",
    productName: "Wireless Charger",
    price: 39.0,
    customer: "Liam Miller",
    date: "2025-09-07",
    status: "Delivered"
  },
  {
    orderId: "ORD-1008",
    productName: "Fitness Tracker",
    price: 99.0,
    customer: "Olivia Davis",
    date: "2025-09-08",
    status: "Placed"
  },
  {
    orderId: "ORD-1009",
    productName: "Portable Projector",
    price: 249.0,
    customer: "James Wilson",
    date: "2025-09-09",
    status: "Processing"
  },
  {
    orderId: "ORD-1010",
    productName: "Noise Cancelling Headphones",
    price: 199.0,
    customer: "Isabella Garcia",
    date: "2025-09-10",
    status: "Delivered"
  },
  {
    orderId: "ORD-1011",
    productName: "Smartphone Case",
    price: 25.0,
    customer: "Ethan Martinez",
    date: "2025-09-11",
    status: "Cancelled"
  },
  {
    orderId: "ORD-1012",
    productName: "Tablet Pro 12.9",
    price: 999.0,
    customer: "Charlotte Rodriguez",
    date: "2025-09-12",
    status: "Placed"
  },
  {
    orderId: "ORD-1013",
    productName: "Wireless Keyboard",
    price: 69.0,
    customer: "Benjamin Lopez",
    date: "2025-09-13",
    status: "Processing"
  }
];

const OrderItems = { PRO_ITEMS_COLUMNS, ROWS};
export default OrderItems;